import { DotLottieWorkerReact } from '@lottiefiles/dotlottie-react'
import { generateReferralLink } from '@utils'
import classNames from 'classnames'
import { useTranslation } from 'react-i18next'

import { useClipboard } from '@ds'
import { LottieFromFrame, useStarAnim } from '@shared'
import { getUserObject } from '@store'

import styles from './InviteLink.module.scss'

type Props = {
  compact?: boolean
  className?: string
}

export const InviteLink = ({ compact, className }: Props) => {
  const { t } = useTranslation()
  const { starAnim } = useStarAnim()
  const { copy } = useClipboard()
  const user = getUserObject()
  const inviteLink = generateReferralLink(user.id)

  const handleCopyLink = () => {
    copy(inviteLink, t('settings.invite.copied'))
  }

  const renderLink = () => {
    return (
      <div className={styles.linkContainer}>
        <p className={styles.linkText}>Link to invite friends</p>
        <button onClick={handleCopyLink} className={styles.copyButton}>
          <span className={styles.copyButtonLabel}>Copy</span>
          <div className={styles.copyButtonGlow} />
        </button>
      </div>
    )
  }

  if (compact) {
    return <div className={classNames(styles.container, className)}>{renderLink()}</div>
  }

  return (
    <div className={classNames(styles.container, className)}>
      <p className={styles.title}>{t('settings.invite.title')}</p>
      {renderLink()}
      {starAnim && (
        <>
          <LottieFromFrame
            data={starAnim}
            width={126}
            height={126}
            className={classNames(styles.starAnim, styles.starAnimLeft)}
            frame={10}
          />
          <DotLottieWorkerReact
            data={starAnim}
            autoplay
            loop
            width={126}
            height={126}
            className={classNames(styles.starAnim)}
          />
          <LottieFromFrame
            data={starAnim}
            width={126}
            height={126}
            className={classNames(styles.starAnim, styles.starAnimRight)}
            frame={20}
          />
        </>
      )}
    </div>
  )
}
